import { UserStatsModel } from './UserStatsModel';

export class UserModel {
    constructor(userData) {
        const stats = this.getUserStats(userData);

        this._user = {
            id: userData.id,
            fullName: userData.fullname,
            email: userData.email,
            type: userData.type,
            mobile: userData.mobile,
            birth: userData.birth,
            sex: userData.sex,
            facebookId: userData.facebook_id,
            googleId: userData.google_id,
            address: userData.address,
            country: userData.country,
            city: userData.city,
            bodyweight: userData.bodyweight,
            height: userData.height,
            latitude: userData.latitude,
            longitude: userData.longitude,
            cover: userData.cover,
            featureType: userData.feature_type,
            invitationCode: userData.invitationCode,
            createdAt: userData.created_at,
            isFollowed: userData.is_followed,
            smallImage: userData.image ? userData.image.data.small_url : null,
            mediumImage: userData.image ? userData.image.data.medium_url : null,
            originalImage: userData.image ? userData.image.data.original_url : null,
            stats,
        };
    }

    get user() {
        return this._user;
    }

    getUserStats(userData) {
        let stats = {};

        if (userData.stats) {
            const statsModel = new UserStatsModel(userData.stats);
            stats = { ...statsModel.stats };
        }

        return stats;
    }
}



// WEBPACK FOOTER //
// ./src/BusinessLogic/Models/UserModel.js